module.exports = __webpack_public_path__ + "media/images/list_practice/7-01-545e1a1a89105bf276f64a08a63474cb.svg";